//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../no/Routing.js";
let d=[[[0,"CablewayPatternMethodType",1,0],[0,"CablewayPatternPartNumber",0,0]],[[[],"Flip",{},0,0],[[],"GetAttributeHolder",{R_:{libraryDefinedAttributeHolder:"Routing.AttributeHolder"}},0,0],[[],"ResetAttributeHolder",{},0,0],[["flip"],"SetFlip",{},1,0],[["etpComponents"],"SetEtpComponents",{},1,0]],[]];
SPLM.RoutingCommon.CablewayPatternBlockBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.CablewayPatternBlockBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.CablewayPatternBlockBuilder.CablewayPatternMethod = Object.freeze({
    "None" : "None", "SpecifiedPattern" : "SpecifiedPattern", "SpecifiedStock" : "SpecifiedStock", "SpecifiedSpaceReservation" : "SpecifiedSpaceReservation"});

export default SPLM;